module.exports = __webpack_public_path__ + "img/product-ketang-zzct-03.974e8b75.png";